/*
    Dropdown은 내부 store를 통해 열고 닫는 등의 상태를 관리하고 있어,
    상태관리 싱크를 맞추기 위해 내부에서 DOM 조작으로 닫지 않고 instance들을 배열에 담아 열린 Dropdown만 닫도록 함
*/

import Dropdown from './index';

class DropdownInstControl {
    private dropdownInstanceArr: Dropdown[] = [];

    addInstance(inst: Dropdown) {
        this.dropdownInstanceArr.push(inst);
    }

    closeOpenDropdown() {
        const openDropdown = this.dropdownInstanceArr.filter(v => v.isOpen);
        if(openDropdown?.length > 0) {
            openDropdown.forEach(v => {
                v.closeLayer();
            });
        }
    }
}

export default new DropdownInstControl();